import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PermissionService } from 'app/security/permission';
import { ROLE } from '../roles.const';
import { UserComponent } from '../user.component';
import { UserFormComponent } from '../user-form/user-form.component';
import { CoachListComponent } from './coach-list/coach-list.component';
import { UserResolve } from '../user.resolve';

const routes: Routes = [
  {
    path: 'coach',
    component: UserComponent,
    data: {
      breadcrumb: 'coach.list'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: CoachListComponent,
        canActivate: [PermissionService],
        data: {
          only: ROLE.ADMIN,
          redirectTo: ''
        }
      },
      {
        path: 'create',
        component: UserFormComponent,
        canActivate: [PermissionService],
        data: {
          breadcrumb: 'coach.create',
          only: ROLE.ADMIN,
          redirectTo: ''
        }
      },
      {
        path: ':userId/edit',
        component: UserFormComponent,
        canActivate: [PermissionService],
        data: {
          breadcrumb: 'coach.edit',
          only: ROLE.ADMIN,
          redirectTo: ''
        },
        resolve: {
          user: UserResolve
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoachRoutingModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/coach/coach-routing.module.ts